import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import ReadOnlyTextField from 'src/components/widgets/readonly-textfield';
import QuillEditor from 'src/components/quill-editor';
import DropdownPartners from 'src/components/dropdown/dropdown-partners';
import StringTextField from 'src/components/widgets/string-textfield';
import DropdownGroups from 'src/components/dropdown/dropdown-groups';
import SubmitButton, { useCustomFormik } from 'src/components/formik-helper';
import PlateTextField from 'src/components/widgets/plate-textfield'
import DropdownPricing from 'src/components/dropdown/dropdown-pricing';
import { mergeNoteFromEditor } from 'src/utils/formatters';
import {
  initialValues,
  validationSchema,
  handleSubmitted,
  formatCardFuel,
} from './formik';

export const DetailView = ({ item, apiChange, assignGroup }) => {
  const editorRef = useRef();

  const formik = useCustomFormik({
    // initialValues: {},
    validationSchema: validationSchema(item),

    onSubmit: async (values, helpers) => {
      const mergeValues = mergeNoteFromEditor(values, editorRef, item.note);
      await handleSubmitted(mergeValues, item, apiChange, assignGroup);
    },
  });

  const [isAssigned, setAssigned] = useState(false);
  useEffect(() => {
    if(formik){
      setAssigned(formik.values.isVerified);
    }
  }, [formik]);

  useEffect(() => {
    initialValues(formik, item);
  }, [item]);

  return (
    <Card>
      <CardContent sx={{ px: 1, py: 2 }}>
        <Grid container spacing={3}>
          <Grid xs={12} md={6}>
          <><Grid container spacing={3}>
              <Grid xs={12} md={6}>
                <PlateTextField transmission={item.transmission} plate={item.plate} />
              </Grid>
              <Grid xs={12} md={6}>
                <ReadOnlyTextField label="Loại xe" value={item.type} />
              </Grid>
              <Grid xs={12} md={6}>
                <ReadOnlyTextField label="Thương hiệu" value={item.brand} />
              </Grid>
              <Grid xs={12} md={6}>
                <ReadOnlyTextField label="Hiệu xe" value={item.name} />
              </Grid>
            </Grid>
          </>
          </Grid>
          <Grid xs={12} md={6}>
            <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={3}>
              <Grid xs={12}>
                <QuillEditor
                  ref={editorRef}
                  value={item.note}
                  sx={{ height: 86 }}
                />
              </Grid>
              <Grid xs={12} md={6}>
                <DropdownPartners
                  name="partnerField"
                  type='xd'
                  formik={formik}
                  hintValue={item.partnerName}
                  disabled={isAssigned}
                  ignoreValues={['0']}
                />
              </Grid>
              <Grid xs={12} md={6}>
                <StringTextField
                  label="Số thẻ"
                  name="cardField"
                  formik={formik}
                  hintValue={formatCardFuel(item.cardNumber)}
                  onChangeValue={(newValue) => {
                    return formatCardFuel(newValue);
                  }}
                  inputProps={{
                    maxLength: 9,
                    onInput: (e) => {
                      e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, '');
                    },
                  }}
                  disabled={isAssigned}
                />
              </Grid>

              <Grid xs={12} md={12}>
                <DropdownPricing
                  name="pricingField"
                  type='xd'
                  formik={formik}
                  hintValue={item.pricingName}
                  showPrice={false}
                  disabled={isAssigned}
                />
              </Grid>
              
              <Grid xs={12} md={12}>
                <DropdownGroups 
                  name="groupField" 
                  type="xe" 
                  label={'Đơn vị'} 
                  onSelected={(val) => {
                    formik.setFieldValue('groupField', val);
                  }}
                  hintValue={item.groupName}
                  disabled={!isAssigned}
                />
              </Grid>
                
              <Grid xs={12} md={11} display="flex"
                sx={{ justifyContent: { xs: 'center', md: 'flex-end' } }}
              >
                <SubmitButton formik={formik} isRemove={true} labelRemove={'Bàn giao xe'} />
              </Grid>
            </Grid>
            </form>
          </Grid>
        </Grid> 
      </CardContent>
    </Card>
  );
};

DetailView.propTypes = {
  item: PropTypes.object.isRequired,
};